import { useCallback, useState } from 'react';
import { ScreeningVoteFunction, Study } from '../StudyList';
import { voteFailureMessage } from './voteFailureMessage';
import { createScreeningVote, SavedVote } from 'query/study/Votes';

export type VotedStudy = {
  studyId: Study['id'];
  voteId: SavedVote['id'];
};

export const useScreeningVotes = ({
  reviewId,
  initialIsTrialLimitReached,
}: {
  reviewId: string;
  initialIsTrialLimitReached: boolean;
}) => {
  const [votedStudies, setVotedStudies] = useState<VotedStudy[]>([]);
  const [isTrialLimitReached, setIsTrialLimitReached] = useState(
    initialIsTrialLimitReached
  );

  const handleScreeningVote: ScreeningVoteFunction = useCallback(
    async (studyId, vote, consensus) => {
      const result = await createScreeningVote({
        reviewId,
        studyId,
        vote,
        consensus,
      });

      if (result.isTrialLimitReached) {
        setIsTrialLimitReached(true);
      }

      if (!result.ok) {
        if (result.isTrialLimitReached) return studyId;

        throw new Error(voteFailureMessage(result.error));
      }

      setVotedStudies((current) => [
        ...current,
        { studyId, voteId: result.vote.id },
      ]);

      return studyId;
    },
    [reviewId]
  );

  return { handleScreeningVote, votedStudies, isTrialLimitReached };
};
